// Configuration des partenaires
export const PARTNERS = {
  place_des_energies: {
    id: 'place_des_energies',
    name: 'Place des Énergies',
    logo: '/logos/place-des-energies.jpg',
    colors: {
      primary: '#397DFF',      // AZUR
      secondary: '#191D1E',    // ANTHRACITE
      accent: '#F9C80E',       // AMBRE
      background: '#F5F6F9',   // BLANC LUNAIRE
      text: '#191D1E'
    },
    fonts: {
      heading: 'Bricolage Grotesque',
      body: 'Karla'
    },
    contact: {
      email: 'mon-etude@placedesenergies.com',
      website: 'www.placedesenergies.com',
      phone: '09.80.80.23.80'
    }
  },
  cousin_hub: {
    id: 'cousin_hub',
    name: 'Cousin Hub',
    logo: '/logos/cousin-hub.jpg',
    colors: {
      primary: '#6899D6',      // Bleu doux Cousin Hub
      secondary: '#000000',    // Noir
      accent: '#6899D6',       // Bleu (même que primary)
      background: '#FFFFFF',   // Blanc
      text: '#000000'
    },
    fonts: {
      heading: 'system-ui',    // Police système par défaut
      body: 'system-ui'
    },
    contact: {
      email: 'pricing@cousin-hub.fr',
      website: 'www.cousin-hub.com',
      phone: '01.XX.XX.XX.XX'
    }
  }
};

export const getPartnerConfig = (partnerId) => {
  return PARTNERS[partnerId] || PARTNERS.place_des_energies;
};
